import { useTranslation } from "react-i18next";
import { Input } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import "components/UploadImage/UploadImage.scss";
import { createFormHelper } from "lib/Form";
import { UploadFilePreview } from "lib/Form/components/FormUploadImage/UploadFilePreview";
import { useUploadCompanyStampMutation } from "modules/DealerLocationDetails/components/General/components/CompanyStampUpload/hooks";
import { clickOnId } from "utils/common";
import { formatDate } from "utils/dateHelperFunctions";

import type { LocationAdminFormPayload } from "modules/DealerLocationDetails";

const COMPANY_STAMP_INPUT_ID = "company-stamp-upload";

const FormHelper = createFormHelper<LocationAdminFormPayload>();

export const CompanyStampUpload = () => {
  const { t } = useTranslation();
  const { watch, setValue } = FormHelper.useFormContext();

  const { mutate: uploadCompanyStamp, isPending: isUploadCompanyStampPending } = useUploadCompanyStampMutation();

  const [locationName, companyStamp] = watch(["name", "company_stamp"]);
  const fileName = companyStamp ? (companyStamp.split("/").pop()?.split("?")[0] ?? "") : "";

  const handleChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;

    uploadCompanyStamp(
      { path: `${locationName}/${formatDate(new Date(), DATE_FORMATS_FNS.yearMonthDateSlash)}`, file },
      { onSuccess: url => setValue("company_stamp", url) }
    );
  };

  return (
    <div className="upload-container">
      <div className="UploadImage new">
        <div className="button" onClick={() => !isUploadCompanyStampPending && clickOnId(COMPANY_STAMP_INPUT_ID)}>
          <p className="btn-text">{t("v8_choose_file", "Choose File")}</p>
        </div>
        <p className="fileInput-ellipsis">{fileName || t("v8_company_stamp", "Company Stamp")}</p>
      </div>
      <Input id={COMPANY_STAMP_INPUT_ID} className="hidden-file-input" accept="image/png, image/jpeg, image/jpg" type="file" onChange={handleChangeFile} />
      <UploadFilePreview image={companyStamp} onDelete={() => setValue("company_stamp", "")} />
    </div>
  );
};
